import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from '@emotion/styled';
import emailSentImage from '../images/check-your-email.svg';
import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { usePageViewedEvent } from '../utilities/analytics/analytics-web-client';

const EmailSentImg = styled.img`
  height: ${gridSize() * 16}px;
  display: block;
  margin: ${gridSize()}px auto ${gridSize() * 2}px;
`;

const Email = styled.p`
  font: ${token('font.heading.small')};
  margin-top: ${gridSize()}px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const TextWrapper = styled.div`
  p {
    margin: 0;
  }
`;

export interface RecoveryEmailSentProps {
  email: string;
  isExpired: boolean;
  expirePageId: string;
  emailSentPageId: string;
}

const RecoveryEmailSent = ({
  email,
  emailSentPageId,
  expirePageId,
  isExpired,
}: RecoveryEmailSentProps) => {
  usePageViewedEvent(isExpired ? expirePageId : emailSentPageId);

  return (
    <>
      <EmailSentImg src={emailSentImage} />
      <TextWrapper>
        {isExpired && (
          <FormattedMessage
            id="mf.recoveryemailsent.expired"
            tagName="p"
            defaultMessage="Your recovery link expired."
          />
        )}
        <FormattedMessage
          id="mf.recoveryemailsent"
          tagName="p"
          defaultMessage="We've emailed instructions to:"
        />
      </TextWrapper>
      <Email>{email}</Email>
    </>
  );
};

export default RecoveryEmailSent;
